<template>
  <div>
    <b-modal id="retrieving-data-from-Server" :title="'Retrieving data'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>
      <div>
        <span>Retrieving data from Server. Please wait.</span>
        <b-spinner label="Loading..."></b-spinner>
      </div>
    </b-modal>
    <b-modal id="modal-edit-item" ref="editModal" size="xl" :disabled='saveInProgress' @ok="handleEditOk" no-close-on-backdrop>
      <template  #modal-title>
        <div v-if="isNew">
        Create new entry
        </div>
        <div v-else>
        <b-button v-if="hasPrevious" :disabled='saveInProgress' title="Previous" @click="previousItem"><b-icon icon="arrow-left-circle-fill" /></b-button>
        Edit Item {{selectedItem.customerId}} ({{itemIndex + 1}} of {{totalItems}})
        <b-button v-if="hasNext" :disabled='saveInProgress' title="Next" @click="nextItem"><b-icon icon="arrow-right-circle-fill" /></b-button>
        </div>
      </template>
      <edit-item v-bind:simple-properties="simpleProperties" v-bind:complex-properties="complexProperties" v-bind:schema="schema"></edit-item>
      <div v-if="saveResult">
        <b-alert class="mt-1"  variant="danger" :show="!saveResult.success" >{{ saveResult.message }}</b-alert>
      </div>
    </b-modal>
    <b-modal id="modal-confirm-delete" :title="'Delete Item '"  @ok="deleteItem">
      <confirm-delete :item="selectedItem"></confirm-delete>
    </b-modal>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p v-if="saveResult">{{ saveResult.message }}</p>
      <b-progress
        variant="success"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px"
      ></b-progress>
    </b-alert>
    <div class="form-group">
      <table width="500px">
        <tr>
          <td style="padding-left: 8px"><v-select multiple v-model="searchedCategories" :options="searchCategories" v-on:change="searchCategoriesChanged" v-on:input="searchCategoriesChanged" placeholder="Search in all categories..."/></td>
        </tr>
        <tr>
          <td style="padding-left: 8px"><input type="text" class="form-control" id="searchText" placeholder="Type search text here..." @change="searchStringChanged($event)"></td>
        </tr>
      </table>
    </div>
    <div>
      <b-table hover :items="items" :fields="fields" striped small bordered responsive="sm" class="m-2">
        <template #thead-top="data">
          <b-tr>
            <b-th class="align-middle"> <b-button title="Add Item" @click="addItem"><b-icon-plus></b-icon-plus></b-button></b-th>
            <b-th class="align-middle" :colspan="fields.length -1">
              <b-pagination
              @change="handlePageChange"
              v-model="page"
              :total-rows="count"
              :per-page="pageSize"
            ></b-pagination></b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="row">
          <b-td>
             <b-button-group vertical >               
                <b-button title="Edit Item" @click="editItem(row.index,row.item)">
                  <b-icon icon="pencil" aria-hidden="true"></b-icon>
                </b-button>
               <b-button title="Copy and Edit" @click="doCopyAndEdit(row.index, row.item)">
                 <b-icon icon="clipboard-plus" aria-hidden="true"></b-icon>
               </b-button>
               <b-button title="Delete Item" @click="confirmDelete(row.item)">
                  <b-icon icon="trash" aria-hidden="true"></b-icon>
                </b-button>
            </b-button-group>
          </b-td>
        </template>
        <template v-slot:cell()="data">
          <span v-b-tooltip.hover :title=data.value>{{ data.value | subStr}}</span>
          <!--alternative way to do tooltips
          <span id="cellEntry" :title=data.value>{{ data.value | subStr}}</span>
          <b-tooltip target="cellEntry">{{ data.value}}</b-tooltip>-->
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>

import {BackendApiService} from '../../services/BackendApiService'
import EditItem from './EditItem'
import ConfirmDelete from './ConfirmDelete'
// eslint-disable-next-line no-unused-vars
import TextInput from './TextInput'
// eslint-disable-next-line no-unused-vars
import EnumInput from './EnumInput'

export default {

  name: 'EntriesTable',
  props: ['schema'],
  methods: {
    getRequestParams (page, pageSize, searchCategories, searchString) {
      let params = {}

      if (page) {
        params['page'] = page - 1
      }

      if (pageSize) {
        params['size'] = pageSize
      }

      if (searchCategories) {
        let searchCategoryString = ''

        searchCategories.forEach((value) => {
          searchCategoryString += value.key + ','
        })

        params['searchCategories'] = encodeURIComponent(searchCategoryString)
      }
      if (searchString) {
        params['searchString'] = encodeURIComponent(searchString.toString())
      }

      return params
    },
    structureReferenceInformationsForUI: function (flattenedItem) {
      flattenedItem.refs.forEach((ref) => {
        if (!ref || !ref.customerRefId) {
          return
        }

        let refValue = ref.customerRefId
        let flattenedRef = ref

        if (flattenedItem[ref.fieldName] == null || flattenedItem[ref.fieldName].toString() === '') {
          flattenedItem[ref.fieldName] = '[' + refValue + '] '
        } else {
          flattenedItem[ref.fieldName] += '/'
        }

        let index = 0
        flattenedRef.properties.forEach((prop) => {
          if (index !== 0) {
            flattenedItem[ref.fieldName] += '_'
          }
          flattenedItem[ref.fieldName] += prop.value
          index++
        })
      })
    },
    retrieveItems () {
      const params = this.getRequestParams(this.page, this.pageSize, this.searchedCategories, this.searchString)

      this.$bvModal.show('retrieving-data-from-Server')
      BackendApiService.getItems(this.schema.id, params, this.$store.getters.username)
        .then((response) => {
          const {items, totalItems} = response.data

          this.items = items.map((item) => {
            let flattenedItem = item			
            flattenedItem.properties.forEach((prop) => {
              flattenedItem[prop.fieldName] = prop.value
            })

            this.structureReferenceInformationsForUI(flattenedItem)
            flattenedItem['id'] = item.id
			flattenedItem['existingInCloud'] = item.existingInCloud == null ? "No" : "Yes"
            return flattenedItem
          })
          this.count = totalItems
          this.totalItems = totalItems
          this.$bvModal.hide('retrieving-data-from-Server')
        })
        .catch((e) => {
          console.log(e)
          this.$bvModal.hide('retrieving-data-from-Server')
        })
    },
    retrieveRefs () {
      return BackendApiService.getRefs(this.schema.id).then((response) => {
        this.refs = response.data
      })
    },
    confirmDelete (item) {
      this.selectedItem = item
      this.$bvModal.show('modal-confirm-delete')
    },
    deleteItem () {
      BackendApiService.deleteItem(this.schema.id, this.selectedItem.id).then((response) => {
        this.retrieveItems()
      })
    },
    addItem () {
      this.copyAndEdit = false
      this.setDataAndOpenEditDialog(-1, null)
    },
    prepareDialog: function () {
      this.retrieveRefs().then(value => {
        this.prepareSimpleProperties()
        this.prepareComplexProperties()
        this.$bvModal.hide('retrieving-data-from-Server')
        this.$bvModal.show('modal-edit-item')
        this.tmpData = null
      })
    },
    setDataAndOpenEditDialog: function (index, item) {
      this.selectedItem = item
      this.saveResult = null
      this.itemIndex = index
      console.log('PrepareDialog')
      this.prepareDialog()
      // Show the modal
      console.log('ShowDialog')
      this.$bvModal.show('retrieving-data-from-Server')
      this.openEditor = true
    },
    editItem (index, item) {
      this.copyAndEdit = false
      this.setDataAndOpenEditDialog(index, item)
    },
    doCopyAndEdit (index, item) {
      this.copyAndEdit = true
      this.setDataAndOpenEditDialog(index, item)
    },
    getInformation (selectedOption) {
      if (selectedOption == null) {
        return ''
      }
      let selectionOptionString = selectedOption.toString()
      let indexOfValue = selectionOptionString.indexOf(']')
      return selectionOptionString.substring(1, indexOfValue)
    },
    saveChanges (callbackFunction) {
	  this.saveInProgress = true
      this.saveResult = null
      this.tmpData = null
      let dataToSave = this.simpleProperties.map((itemProp) => [itemProp.definition.name, itemProp.value])
      let complexData = this.complexProperties.map((itemProp) => [itemProp.definition.name, this.getInformation(itemProp.selectedOption)])
      dataToSave = dataToSave.concat(complexData)
      let itemProps = Object.fromEntries(dataToSave)
      let itemId = (this.isNew || this.copyAndEdit) ? 'new' : this.selectedItem.id

      return BackendApiService.saveItem(this.schema.id, itemId, itemProps).then((response) => {
        console.log('received response on save ', response)
        this.saveResult = response.data
        if (!this.isNew) {
          this.selectedItem = this.saveResult.savedItem
          this.items[this.itemIndex - this.pageSize * (this.page - 1)] = this.saveResult.savedItem
        }
        this.showAlert()
        this.retrieveItems()
        if (callbackFunction) {
          callbackFunction(true)
        }
      }).catch((error) => {
        if (error.response) {
          console.log('received error with response on save  ', error.response)
          this.saveResult = error.response.data
          return error.response.data
        } else {
          console.log('received error without response on save')
          this.saveResult = {success: false, message: 'No error response: ' + error.message, modified: false}
          return this.saveResult
        }
      })
    },
    handleEditOk (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.saveChanges((responseSucess) => {
        if (responseSucess) {
          this.$bvModal.hide('modal-edit-item')
          this.openEditor = false
		  this.saveInProgress = false
        } else {
          const parsedResponse = JSON.parse(this.response)
          if (parsedResponse && parsedResponse.success) {
            this.$bvModal.hide('modal-edit-item')
            this.openEditor = false
			this.saveInProgress = false
          }
        }
      })
    },
    previousItem () {
      this.saveChanges((responseSucess) => {
        if (responseSucess) {
          this.itemIndex = this.itemIndex - 1
          if (this.itemIndex < this.pageSize * (this.page - 1)) {
            this.handlePageChange(this.page - 1)
          }
          this.selectedItem = this.items[this.itemIndex - this.pageSize * (this.page - 1)]
          this.prepareSimpleProperties()
          this.prepareComplexProperties()
        }
      })
    },
    nextItem () {
      this.saveChanges((responseSucess) => {
        if (responseSucess) {
          this.itemIndex = this.itemIndex + 1
          if (this.itemIndex >= this.pageSize * this.page) {
            this.handlePageChange(this.page + 1)
          }
          this.selectedItem = this.items[this.itemIndex - this.pageSize * (this.page - 1)]
          this.prepareSimpleProperties()
          this.prepareComplexProperties()
        }
      })
    },
    createItemPropertyForPropDefinition (propDef) {
      let result = {component: 'TextInput', definition: propDef, value: null, options: [], selectedOption: null}
      if (propDef.ref) {
        if (this.selectedItem && this.selectedItem.refs) {
          let refs = this.selectedItem.refs.filter((ref) => {
            if (ref.fieldName === propDef.name) {
              return ref
            }
          })
          if (refs.length > 0) {
            result.value = refs[0].customerRefId
          }
        }

        if (this.tmpData) {
          for (const item in this.tmpData) {
            if (item === propDef.name) {
              result.value = this.tmpData[item]
            }
          }
        }

        let mappedOptions = Object.entries(this.refs[propDef.name]).map(([key, value]) => [key, this.labelForRefValue(value)])

        mappedOptions.forEach((key, value) => {
          result.options.push(key[1])
          if (key[0] === result.value) {
            result.selectedOption = key[1]
          }
        })
        result.refDef = propDef
        result.component = 'RefInput'
      } else {
        if (propDef.enum) {
          let mappedOptions = propDef.validOptions.map((value) => [value, value])
          mappedOptions.forEach((key, value) => {
            result.options.push(key[0])
          })

          result.component = 'EnumInput'
        }
        if (this.selectedItem && this.selectedItem.properties) {
          let props = this.selectedItem.properties.filter((prop) => {
            if (prop.fieldName === propDef.name) return prop
          })

          if (props.length > 0) {
            result.value = props[0].value
          }
        }

        if (this.tmpData) {
          for (const item in this.tmpData) {
            if (item === propDef.name) {
              result.value = this.tmpData[item]
            }
          }
        }
      }

      return result
    },
    labelForRefValue (refValues) {
      let label = ''
      refValues.forEach((refValue, index) => {
        if (index === 0) {
          label += '[' + refValue.customerRefId + '] '
        }
        if (index > 0) {
          label += ' / '
        }
        refValue.properties.forEach((prop, indexB) => {
          if (indexB > 0) {
            label += '_'
          }
          label += prop.value
        })
      })
      return label
    },

    prepareSimpleProperties () {
      if (!this.schema) {
        return
      }
      var newItemProperties = []
      let ownerProp = {component: 'TextInput', definition: {name: 'owner', title: 'Owner', description: 'The owner'}, value: null, options: [], readonly: true}
      let customerProp = {component: 'TextInput', definition: {name: 'customerId', title: 'Customer ID', description: 'The company id becomes the foreign key in the cloud'}, value: null, options: [], readonly: false}
      let activeProp = {component: 'CheckBoxInput', definition: {name: 'active', title: 'Active', description: 'Switched if entry is active'}, value: true, options: [], readonly: false}
      let companyIdProp = {component: 'TextInput', definition: {name: 'companyId', title: 'Company ID', description: 'The company ID'}, value: null, options: [], readonly: false}

      if (this.selectedItem) {
        ownerProp.value = this.selectedItem.owner ? this.selectedItem.owner.userID : ''
        companyIdProp.value = this.selectedItem.companyId
        activeProp.value = this.selectedItem.active
        customerProp.value = this.selectedItem.customerId
      }
      if (this.tmpData) {
        companyIdProp.value = this.tmpData.companyId
        activeProp.value = this.tmpData.active
        customerProp.value = this.tmpData.customerId
      }
      if (this.isNew) {
        BackendApiService.generateId(this.schema.id).then((result) => {
          customerProp.value = result.data
        })
      } else {
        newItemProperties.push(ownerProp)
      }

      newItemProperties.push(activeProp)
      newItemProperties.push(customerProp)
      newItemProperties.push(companyIdProp)

      this.schema.simpleProperties.forEach((propDef) => {
        let itemProp = this.createItemPropertyForPropDefinition(propDef)
        newItemProperties.push(itemProp)
      })
      this.simpleProperties = newItemProperties
    },
    prepareComplexProperties () {
      let newComplexProperties = []
      this.schema.refProperties.forEach((propDef) => {
        let itemProp = this.createItemPropertyForPropDefinition(propDef)
        newComplexProperties.push(itemProp)
      })
      this.complexProperties = newComplexProperties
    },
    handlePageChange (value) {
      console.log('changing page to ', value)
      this.page = value
      this.retrieveItems()
    },
    searchCategoriesChanged (event) {
      this.retrieveItems()
    },
    searchStringChanged (event) {
      this.searchString = event.target.value
      this.retrieveItems()
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  },
  components: {
    EditItem, ConfirmDelete
  },
  mounted () {
    this.retrieveItems()
  },
  data () {
    return {
      page: 1,
      count: 0,
      pageSize: 10,
      items: [],
      refs: {},
      selectedItem: {},
      itemIndex: 0,
      copyAndEdit: false,
      totalItems: 0,
      simpleProperties: [],
      complexProperties: [],
      searchCategories: [],
      searchedCategories: [],
      searchString: '',
      saveResult: null,
      dismissSecs: 3,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      rowSelected: [],
      tmpData: null,
      openEditor: false,
	  saveInProgress: false
    }
  },
  filters: {
    subStr: function (string) {
      let stringToShorten = string.toString()
      if (stringToShorten.length >= 30) {
        return string.toString().substring(0, 27) + '...'
      } else {
        return string
      }
    }
  },

  computed: {
    fields (x) {
      let result = [{key: 'actions', label: ''}, {key: 'existingInCloud', label: 'Synched with DMIx'}, {key: 'active', label: 'Active'}, {key: 'customerId', label: 'Customer ID'}, {key: 'owner.userID', label: 'Owner'}, {key: 'companyId', label: 'Company ID'}]
      let searchHeader = [{key: 'existingInCloud', label: 'Linked with DMIx'}, {key: 'customerId', label: 'Customer ID'}, {key: 'companyId', label: 'Company ID'}]
      this.schema.simpleProperties.forEach((value, index) => {
        result.push({key: value.name, label: value.title})
        searchHeader.push({key: value.name, label: value.title})
      })

      this.schema.refProperties.forEach((value, index) => {
        result.push({key: value.name, label: value.title})
        searchHeader.push({key: value.name, label: value.title})
      })

      result.push()
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.searchCategories = searchHeader
      return result
    },
    hasPrevious () {
      return this.itemIndex > 0
    },
    computedItemProperties () {
      let result = []
      result.push(this.simpleProperties)
      result.push(this.refProperties)
      return result
    },
    hasNext () {
      return this.itemIndex < this.totalItems - 1
    },
    isNew () {
      return this.selectedItem == null
    }
  },
  watch: {
    '$store.state.update': {
      handler: function () {
        this.retrieveItems()
      },
      immediate: true,
      deep: true
    },
    '$store.state.refUpdate': {
      handler: function () {
        this.retrieveItems()

        if (!this.openEditor) {
          return
        }

        let dataToSave = this.simpleProperties.map((itemProp) => [itemProp.definition.name, itemProp.value])
        let complexData = this.complexProperties.map((itemProp) => [itemProp.definition.name, this.getInformation(itemProp.selectedOption)])
        dataToSave = dataToSave.concat(complexData)
        this.tmpData = Object.fromEntries(dataToSave)
        this.tmpData[this.$store.state.newRefFieldName] = this.$store.state.newRefId
        this.setDataAndOpenEditDialog(this.itemIndex, this.selectedItem)
      },
      immediate: true,
      deep: true
    },
    searchedCategories: function (newVal) {
      this.retrieveItems()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/EntriesTable.vue